import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPaystub, getPaystubs } from '../../../reducers/users';
// import { history } from '../../../configuration/store';
import { saveAs } from 'file-saver';

import './paystubs.css';
import moment from 'moment';

class PaystubList extends React.Component {
    componentDidMount() {
        let { userId, getPaystubs } = this.props;
        if (userId) {
            getPaystubs(userId);
        }
    }

    dateSort(a, b) {
        return a.CheckDate > b.CheckDate ? -1 : a.CheckDate < b.CheckDate ? 1 : 0;
    }

    downloadFile({ data }, name) {
        try {
            saveAs(new Blob([new Uint8Array(data)], { type: 'application/pdf' }), name);
        } catch (error) {
            console.log(error);
        }
    }

    handleDownload(paystubId, checkDate) {
        const fileName = `Pay Stub ${checkDate}.pdf`;
        const { getPaystub, userId } = this.props;
        getPaystub(userId, paystubId, ({ data }) => {
            try {
                saveAs(new Blob([new Uint8Array(data)], { type: 'application/pdf' }), fileName);
            } catch (error) {
                console.log(error);
            }
        });
    }

    render() {
        const { paystubs } = this.props;
        const sortedPaystubs = paystubs.sort(this.dateSort);
        return (
            <div className="row">
                {sortedPaystubs.map((paystub, i) => {
                    const checkDate = moment(paystub.CheckDate).format('YYYY-MM-DD');
                    const paystubId = paystub.ReportId;
                    return (
                        <div className="col-xs-12 paystub-item" key={i}>
                            <div className="row">
                                <div className="col-md-5 col-xs-10" onClick={() => this.handleDownload(paystubId, checkDate)}>
                                    <span className="paystub-name">Download Pay Stub: {checkDate}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

PaystubList.defaultProps = {
    paystubs: []
};

PaystubList.propTypes = {
    userId: PropTypes.string,
    paystubs: PropTypes.array
};

const mapStateToProps = state => ({
    paystubs: state.users.paystubs
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPaystub,
            getPaystubs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PaystubList);



// WEBPACK FOOTER //
// ./src/components/lists/paystubs/index.jsx